import {Injectable} from "@angular/core";
import { StaticValuesUtils } from '../../utils/static-values/static-values.utils';
import * as _ from 'lodash';

function _window(): any {
    // Return the native window obj
    return window;
}

@Injectable({providedIn: 'root'})
export class WindowService {
    constructor() {}

    get nativeWindow(): any {
        return _window();
    }

    getPeggy() {
        return this.nativeWindow.Peggy ?
            this.nativeWindow.Peggy : null;
    }

    getHref() {
        return  this.nativeWindow.location ? this.nativeWindow.location.href : null;
    }

    scrollToTop() {
        document.body.scrollIntoView();
    }


    isWebview(): boolean {
        return StaticValuesUtils.isWebview();
    }

    lockScroll(goToTop: boolean) {
        if (!this.isScrollLocked) {
            document.body.classList.add('scroll-lock');
            document.ontouchmove = function(e) { e.preventDefault(); };
            if (goToTop) {
                this.scrollToTop();
            }
        }
    }

    unlockScroll() {
        if (this.isScrollLocked) {
            document.body.classList.remove('scroll-lock');
            document.ontouchmove = function(e) { return true; };
        }
    }

    get isScrollLocked() {
        return document.body.classList.contains('scroll-lock');
    }

    get screenWidth(): number {
        return this.nativeWindow.innerWidth;
    }

    get isMobile() {
        return this.screenWidth < 768;
    }

    get isDesktop() {
        return this.screenWidth >= 1024;
    }

    get country(): string {
        return this.nativeWindow.country;
    }

    scrollTo(id: string) {
        const element = document.getElementById(id);
        if (!_.isNil(element)) {
            document.documentElement.scrollTop = document.body.scrollTop = _.get(element, 'offsetTop') - 10;
        }
    }

    scrollToContainer() {
        document.getElementsByClassName('wrapper-filters-top')[0].scrollIntoView({behavior: 'smooth'});
    }

    preventScrollRestoration(): void {
        try {
        if (this.nativeWindow.history.scrollRestoration) {
            this.nativeWindow.history.scrollRestoration = 'manual';
          }
        } catch(e) {}
    }

    pageViewId(): string {
        return this.nativeWindow.pageViewId;
    }

    get product(): string {
        return 'transfers';
    }

    goToUrl = (url: string): void => {
        this.nativeWindow.location.href = url;
    }

    newrelicPageAction(name: string, json) {
        this.nativeWindow.newrelic.addPageAction(name, json);
    }

}
